import _ from 'lodash';
import options, {
  selectionModel,
  selectionModelCont,
} from '@/app/utils/toolkit/business-rules/inv-strat-review/reviewReasons';

const mStep = {
  title: 'Review',
  description: 'Please provide details of the investment strategy review.',
};

export default {
  name: 'inv-strat-review-specific-review',
  data: () => ({
    mStep,
    selections: _.cloneDeep(selectionModel()),
    oldSelections: _.cloneDeep(selectionModel()),
    other: {},
    options: _.cloneDeep(options),
  }),
  computed: {
    getItem() {
      return this.$store.getters['toolkit/getItemData'];
    },
    reviewReasons() {
      return _.cloneDeep(this.getItem.review.specific.reasons);
    },
    sections() {
      return this.options.flatMap(section => ({
        label: section.label,
        options: section.options.flatMap(option => option.value),
      }));
    },
    isChecked() {
      return (section, option) => {
        if (
          this.selections[section.label][option.value].selection
          instanceof Array
        ) {
          return (
            this.selections[section.label][option.value].selection.length > 0
          );
        }
        return this.selections[section.label][option.value].selection;
      };
    },
    isChildChecked() {
      // eslint-disable-next-line max-len
      return (section, option, value) => this.selections[section.label][option.value].selection.includes(value);
    },
  },
  watch: {
    selections: {
      deep: true,
      handler(value) {
        // eslint-disable-next-line no-restricted-syntax
        Object.keys(value).forEach((section) => {
          Object.keys(value[section]).forEach((option) => {
            if (value[section][option].selection instanceof Array && !value[section][option].selection.includes('other')) {
              value[section][option].other = '';
            }
          });
        });
        const item = {
          review: {
            specific: {
              replace: true,
              reasons: _.cloneDeep(value),
            },
          },
        };
        if (!_.isEqual(value, this.oldSelections)) {
          item.review.specific.sectionReasons = selectionModelCont();
        }
        this.setItem(item);
        this.oldSelections = _.cloneDeep(value);
      },
    },
  },
  methods: {
    setItem(item) {
      this.$store.dispatch('toolkit/updateItemKey', { data: item });
    },
    handleNextStep() {
      this.$emit('nextStep');
    },
    handleBackStep() {
      this.$emit('backStep');
    },
  },
  activated() {
    if (Object.keys(this.reviewReasons).length > 0) {
      this.selections = _.cloneDeep(this.reviewReasons);
      this.oldSelections = _.cloneDeep(this.reviewReasons);
    }
  },
  validations: {
    selections: {
      hasSelection(value) {
        let hasSelection = false;
        Object.keys(value).forEach((section) => {
          Object.keys(value[section]).forEach((option) => {
            if (
              value[section][option]
              && value[section][option].selection instanceof Array
              && value[section][option].selection.length > 0
            ) {
              hasSelection = true;
            } else if (
              value[section][option]
              && !(value[section][option].selection instanceof Array)
              && value[section][option].selection
            ) {
              hasSelection = true;
            }
          });
        });
        return hasSelection;
      },
    },
  },
};
